import { FinnairPassengerCode } from '@fcom/dapi/api/models';

import { Passenger, Passengers } from '../api/models';

/**
 * To check whether the passenger is a trip lead
 * @param Passenger Passenger to check
 */
export const isTripLead = (p: Passenger): boolean => p.type === FinnairPassengerCode.ADT;

/**
 * To check whether the passenger is a child
 * @param Passenger Passenger to check
 */
export const isChild = (p: Passenger): boolean => p.child;

/**
 * Returns true if selected pax would result in situation where the pnr is split
 * and a child would be separated from the parent/trip lead
 * @param selectedPax selected passengers information for the trip
 * @param pax all passengers in booking
 */
export const childIsTravellingAlone = (selectedPax: Passengers, pax: Passengers): boolean => {
  const notSelectedPax = pax.filter((p) => !selectedPax.map(({ passengerId }) => passengerId).includes(p.passengerId));

  const amountOfChildrenToUpgrade = selectedPax.filter(isChild).length;
  const amountOfTripLeadsToUpgrade = selectedPax.filter(isTripLead).length;

  const amountOfChildrenNotToUpgrade = notSelectedPax.filter(isChild).length;
  const amountOfTripLeadsNotToUpgrade = notSelectedPax.filter(isTripLead).length;

  return (
    (amountOfChildrenNotToUpgrade > 0 && amountOfTripLeadsNotToUpgrade === 0) ||
    (amountOfChildrenToUpgrade > 0 && amountOfTripLeadsToUpgrade === 0)
  );
};

/**
 * By default only id's for the selected passengers are in the basket
 * this function adds the additional info from the passenger info in booking
 * @param selectedPax selected passenger id's for the trip
 * @param pax all passengers in booking
 */
export const enrichSelectedPaxWithInfo = (selectedPax: string[], pax: Passengers): Passengers =>
  pax.filter((p) => selectedPax.includes(p.passengerId));

/**
 * Returns minimum amount of passenger to upgrade.
 * For example if has 1 child and 1 adult, both need to be upgraded
 * @param Passengers All passengers in booking
 */
export function getMinPaxAmountToUpgrade(pax: Passengers): number {
  const amountOfChildren = pax.filter(isChild).length;
  const amountOfTripLeads = pax.filter(isTripLead).length;

  // If multiple trip leads, one of them can be upgraded
  // and children will travel one of the remaining
  if (amountOfTripLeads > 1) {
    return 1;
  } else if (pax.length) {
    // Otherwise all children will need to be upgraded with the trip lead
    return amountOfChildren + 1;
  }

  // Fall back to 0 if no passengers
  return 0;
}
